<template>
    <div ref="filterObj" v-if="Object.keys(filterData).length > 0" v-show="open || (!aside && open)"
        :class="[aside ? asideCss : 'ct-offcanvas-panel map-filter-types-panel d-none', showPanel ? 'd-md-block' : '']">
        <div class="panel-filter-types" :class="[{'aside': aside}, {'open': open}]">
            <template v-if="aside">
                <div :class="asideCssHeader">
                    <a class="" aria-controls="#aside-map-filter-types" href="#aside-map-filter-types"
                        data-toggle="collapse" role="button" :aria-expanded="show" @click.prevent="show=!show" >
                        <div class="title">
                            Tipificação
                            <span class="right icon-collapse svg" :class="{'show': show}"></span>
                        </div>
                    </a>
                </div>
            </template>
            <div class="row no-gutters filter-close" v-if="!aside">
                <div class="col d-flex justify-content-center" >
                    <span class="icon-center text-center" @click.prevent="tooglePanel">
                        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="angle-up" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512" class="rotate-icon svg-inline--fa fa-angle-up fa-w-8 fa-1x"><path fill="currentColor" d="M136.5 185.1l116 117.8c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0L128 224.7 27.6 326.9c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17l116-117.8c4.7-4.6 12.3-4.6 17 .1z" class=""></path></svg>
                    </span>
                </div>
            </div>
            <div :class="[asideCssBody, {'show': show}]">
                <div class="form-check-filter d-flex"
                    :class="[aside ? 'btn-group-vertical' : 'btn-group']"
                    data-toggle="buttons"
                    aria-label="Filter Types">
                    <label
                        v-for="type in filterData"
                        :key="type.id"
                        @click.prevent="!isActionMap && filterOccurrenceByStatusAndType(propName, type.id)"
                        class="btn z-depth-0 col m-0 p-0"
                        :class="{'btn-silver': !aside, 'active': type.show}">

                        <input class="form-check-input" type="checkbox" autocomplete="off" :disabled="isActionMap">
                        <div class="filter-content d-flex" :class="{'flex-column h-100': !aside}">
                            <div class="d-flex flex-fill" :class="[showNumber && posNumber == 'top' ? 'justify-content-start' : 'justify-content-between', {'flex-column': !aside}]">
                                <div class="filter-text" :class="[ showNumber && posNumber == 'top' ? 'order-2' : 'order-1' ]" >{{type.name}}</div>
                                <div class="filter-number" :class="[ showNumber && posNumber == 'top' ? 'order-1' : 'order-2' ]" v-if="showNumber">
                                    <number :from="0" :to="type.qty" :duration="2" :delay="0" easing="Power1.easeOut"/>
                                </div>
                            </div>
                        </div>
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import MapFilterMixin from '../mixins/MapFilterMixin';

    export default {
        mixins: [
            MapFilterMixin
        ],
        props: {
            // initialOpen: {
            //     type: Boolean,
            //     default: true
            // },
            showNumber:{
                type: Boolean,
                default: true
            },
            posNumber: {
                type: String,
                default: 'bottom',
                validator: (value) => [
                    'top',
                    'bottom'
                ].includes(value.toLowerCase())
            },
            propName: {
                type: String,
                default: 'type',
            }
        },
        data() {
            return {
                idPanel: 'filtertype',
                show: this.asideExpanded,
                // open: false,
                previousStatus: false,
            }
        },
        mounted() {
            if(!this.aside){
                // this.open = this.collapsed;
                this.previousStatus = this.collapsed;
            }
        },
        created() {
            this.$eventBus.listen(this.moduleCode, 'map.loaded', this.initialize);
            if(!this.aside){
                this.$eventBus.listen(this.moduleCode, 'map.new-feature-initialize', this.onNewFeatureInitialize);
                this.$eventBus.listen(this.moduleCode, 'map.new-feature-finished', this.onNewFeatureFinished);
            }
        },
        beforeDestroy() {
            this.$eventBus.remove(this.moduleCode, 'map.loaded', this.initialize);
            if(!this.aside){
                this.$eventBus.remove(this.moduleCode, 'map.new-feature-initialize', this.onNewFeatureInitialize);
                this.$eventBus.remove(this.moduleCode, 'map.new-feature-finished', this.onNewFeatureFinished);
            }
        },
        computed: {
            filterData() {
                return this.moduleCode ? this.$store.getters[`${this.moduleCode}/getFilterTypesMap`] : [];
            },
            open() {
                return !this.collapsed;
            }
        },
        methods:{
            initialize: function(data) {
                if(this.open){
                    this.publishHeight();
                }
            },
            tooglePanel() {
                this.collapsedPanel(this.open);
            },
            collapsedPanel(flag) {
                this.$store.dispatch(`${this.moduleCode}/setPanel`, {
                    id: this.idPanel,
                    collapsed: flag,
                });
            },
            publishHeight() {
                this.$nextTick(function () {
                    if(!this.aside && this.$refs.filterObj){
                        this.$store.dispatch(`${this.moduleCode}/setPanel`, {
                            id: this.idPanel,
                            show: this.isPanelVisible,
                            height: this.$refs.filterObj.clientHeight,
                        });
                    }
                });
            },
            onNewFeatureInitialize() {
                this.previousStatus = this.collapsed ? true : false;
                this.collapsedPanel(true);
                this.closePanel();
            },
            onNewFeatureFinished() {
                this.openPanel();
                this.collapsedPanel(this.previousStatus);
            },
        },
        watch: {
            collapsed: {
                immediate: false,
                handler(value, oldValue){
                    setTimeout(() => {
                        this.publishHeight();
                    }, 800)
                },
            },
            filterData: {
                immediate: true,
                handler(value, oldValue){
                    setTimeout(() => {
                        this.publishHeight();
                    }, 800)
                },
            },
        }
    }
</script>

<style scoped lang="scss">

</style>